import raw from "./raw/warning.svg";
import { IconBuilder } from "./builder/IconBuilder";

export const Warning = IconBuilder({
    svg: raw,
    defaultColor: theme => theme.error
});
